import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { Header } from './Header';
import { Helmet } from 'react-helmet';
import { clarity } from 'helpers/clarity';
import { setInitialClarityTags } from 'helpers/clarityHelper';
import { isClarityIncluded } from './helper';
import authHelper from 'helpers/authHelper';

const PowertrainOverviewComponent = ({
    model: { user, selectedGeneralFilter },
    children
}) => {
    return (
        <div className='pt-overview-component'>
            {authHelper.areAllTokensValid() &&
                <Helmet>
                    {!isClarityIncluded() && <script type='module' src={clarity()} />}
                    {setInitialClarityTags(user)}
                </Helmet>
            }
            <Header selectedOrganization={selectedGeneralFilter?.organizations[0]} />
            <Container fluid className='pt-overview-content'>
                <div className='pt-overview-children'>
                    {children}
                </div>
            </Container>
        </div>
    );
};

PowertrainOverviewComponent.propTypes = {
    model: PropTypes.shape({
        user: PropTypes.object,
        selectedGeneralFilter: PropTypes.shape({
            organizations: PropTypes.arrayOf(PropTypes.shape({
                organizationID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                isPowertrainOrganization: PropTypes.bool
            }))
        })
    }).isRequired,
    children: PropTypes.node
};

export default PowertrainOverviewComponent;
